package top.wcpe.allincore.ui.runtime.render

import top.wcpe.allincore.layout.engine.Box
import top.wcpe.allincore.ui.runtime.element.UIElement
import top.wcpe.allincore.ui.runtime.render.UiRenderBridge
import top.wcpe.allincore.ui.runtime.render.model.RenderLayer

/**
 * 单元素渲染策略：把单个 [UIElement] 在已知绝对包围盒下绘制到 [UiRenderBridge]。
 */
interface Renderer {

    /**
     * 本渲染器绘制的目标层。
     * 单层渲染器必须声明正确层（非 BACKGROUND 的必须重写）。
     * 多层渲染器（[LayerRenderers]）返回 null，由内部自行切层。
     */
    fun layer(): RenderLayer? = RenderLayer.BACKGROUND

    /**
     * 旧签名：兼容现有 25 个不依赖 [RenderContext] 的渲染器。
     * 实现类必须覆盖此方法或新签名其一。
     */
    fun render(element: UIElement<*>, box: Box, bridge: UiRenderBridge)

    /**
     * 新签名：渲染器若需要查询平台能力（槽内物品 / 失败反馈 / cursor 状态等），覆盖此方法。
     * 默认转发到旧签名（丢弃 context），让仅实现旧签名的渲染器透明工作。
     */
    fun render(element: UIElement<*>, box: Box, bridge: UiRenderBridge, context: RenderContext) {
        render(element, box, bridge)
    }
}
